<template>
  <div class="cardFooterDetails">
    <div
      v-if="productLevel.readingUnits || productLevel.reportUnits"
      class="pulseInfo"
    >
      <div>
        {{ $t('sites.nodes.readingUnit') }} : {{ productLevel.readingUnits }}
      </div>
      <div>
        {{ $t('sites.nodes.reportUnit') }} : {{ productLevel.reportUnits }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'ProductLevelDetails',
    props: {
        productLevel: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style scoped lang="scss">
@import '@/assets/styles/components/_analysisGrid.scss';
  .cardFooterDetails {
      background-color: #f0f7f4;
  }
  .pulseInfo {
    display: flex;
    justify-content: space-between;
  }

</style>
